"use client";

import { useEffect } from "react";

import { SW_SCOPE, SW_URL } from "@/lib/pwa/sw-messages";

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    if (process.env.NODE_ENV !== "production") {
      // Dev: ensure no stale SW from a prior production build is still controlling the page.
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => {
          for (const reg of regs) reg.unregister();
        })
        .catch(() => {
          // best-effort cleanup; ignore failures
        });
      return;
    }

    const onLoad = () => {
      navigator.serviceWorker.register(SW_URL, { scope: SW_SCOPE, updateViaCache: "none" }).catch((err) => {
        console.warn("[pwa] service worker registration failed", err);
      });
    };

    if (document.readyState === "complete") onLoad();
    else window.addEventListener("load", onLoad, { once: true });

    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, []);

  return null;
}
